import BannerA from '../components/BannerA';
import CompareA from '../components/CompareA';
import FooterTcA from '../components/FooterTcA';
import HighlightsA from '../components/HighlightsA';
import ListA1 from '../components/ListA1';
import ListA2 from '../components/ListA2';
import ListA3 from '../components/ListA3';
import ListA4 from '../components/ListA4';
import ListA5 from '../components/ListA5';
import PageNavA from '../components/PageNavA';
import SectionA1 from '../components/SectionA1';
import SectionA2 from '../components/SectionA2';
import SectionA3 from '../components/SectionA3';
import SectionA4 from '../components/SectionA4';
import SectionA5 from '../components/SectionA5';
import TabA1 from '../components/TabA1';

export default function StatusItem() {
    return (
        <>
            <BannerA />
            <PageNavA />
            <SectionA1 />
            <ListA1 />
            <SectionA2 />
            <SectionA3 />
            <HighlightsA />
            <CompareA />
            <TabA1 />
            {/* <ListA2 /> */}
            <SectionA4 />
            <SectionA5 />
            <ListA3 />
            <ListA4 />
            {/* <ListA5 /> */}
            <FooterTcA />
        </>
    );
}
